import { Colors } from '@ptml/design-system';

class ContactView extends HTMLElement {
    public connectedCallback(): void {
        this.render();
    }

    public render(): void {
        this.innerHTML = `
            <style>
                .header {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 30vh;
                }

                .header img {
                    z-index: 1;
                    object-fit: contain;
                    width: 50%;
                    height: auto;
                    max-height: 25vh;
                }

                .header-background {
                    margin-top: -30vh;
                }

                .header-background img {
                    width: 100%;
                    height: 30vh;
                    object-fit: cover;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                }

                .text-container {
                    letter-spacing: 0.05rem;
                    color: ${Colors.Grey85};
                    line-height: 1.5;
                    padding: 0 2rem;
                }

                .text-container h1,
                .text-container h2,
                .text-container p {
                    margin: 0.5rem 0;
                }

                .text-container h1,
                .text-container a {
                    color: ${Colors.Blue85};
                }

                .text-container > *:last-child {
                    margin-bottom: 0;
                }
            </style>
            <div class="header">
                <img src="/surepart-logo.png" alt="SurePart logo" />
            </div>
            <div class="header-background">
                <img src="/contact_background.jpg" alt="" aria-hidden="true" />
            </div>
            <div class="text-container">
                <h1 data-testid="page-title">Contact Us</h1>
                <h2 data-testid="support-enquiries-heading">Support Enquiries</h2>
                <p data-testid="support-enquiries-text">
                    If you need assistance, you can call our Support Center Team at <a data-testid="phone-link" href="tel:+18557071030">855-707-1030</a>, or email us at 
                    <a data-testid="support-email-link" href="mailto:support@surepart.com?subject=Support for SurePart">support@surepart.com</a>.
                </p>
                <h2 data-testid="feedback-heading">Feedback</h2>
                <p data-testid="feedback-text">
                    We're always working to improve our customer experience, so we'd love to hear what's working for you and how we could do better.
                </p>
                <p data-testid="feedback-prompt-text">
                    To provide feedback, email us at 
                    <a data-testid="feedback-email-link" href="mailto:feedback@surepart.com?subject=Feedback for SurePart">feedback@surepart.com</a>.
                </p>
            </div>
        `;
    }
}

// Register the custom element
customElements.define('contact-view', ContactView);

export { ContactView };
